// components/StatutBadges/StatutBadges.js
import React from "react";
import { Badge } from "react-bootstrap";
import { getBadgeVariant } from "../../utils/facturationUtils";

function StatutBadges({ statusCounts, selectedStatut, setSelectedStatut }) {
  return (
    <div className="statut-badges">
      <Badge
        key="all"
        bg={selectedStatut === null ? "dark" : "secondary"}
        className={`me-2 ${selectedStatut === null ? "active" : ""}`}
        onClick={() => setSelectedStatut(null)}
        style={{
          cursor: "pointer",
          opacity: selectedStatut === null ? 1 : 0.6,
        }}
      >
        Tous ({Object.values(statusCounts).reduce((a, b) => a + b, 0)})
      </Badge>

      {Object.entries(statusCounts).map(([statut, count]) => (
        <Badge
          key={statut}
          bg={getBadgeVariant(statut)}
          className={`me-2 badge-clickable}${
            selectedStatut === statut ? " active" : ""
          }`}
          onClick={() =>
            setSelectedStatut(statut === selectedStatut ? null : statut)
          }
          style={{
            cursor: "pointer",
            opacity: selectedStatut === statut ? 1 : 0.6,
          }}
        >
          {`${statut} (${count})`}
        </Badge>
      ))}
    </div>
  );
}

export default StatutBadges;
